import React from 'react';

const SaveIcon: React.FC = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.17 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V4.83C18 4.3 17.79 3.79 17.41 3.42L14.58 0.59C14.21 0.21 13.7 0 13.17 0ZM9 15C7.34 15 6 13.66 6 12C6 10.34 7.34 9 9 9C10.66 9 12 10.34 12 12C12 13.66 10.66 15 9 15ZM11 7H4C3.45 7 3 6.55 3 6V4C3 3.45 3.45 3 4 3H11C11.55 3 12 3.45 12 4V6C12 6.55 11.55 7 11 7Z"
        fill="white"
      />
    </svg>
  );
};

export default SaveIcon;
